import React from 'react'

export const setFillThemeVarColor = (color: string) => {
  const glyphs = {
    'u-fillColorWhite': '#fff',
    'u-fillColorBrand': '#003d6d',
    'u-fillColorBrandMidnight': '#00284a',
    'u-fillColorActionBlue': '#046cb8',
    'u-fillColorNeutralGrey': '#1f2226',
    'u-fillColorBerry': '#962364',
    'u-fillColorAlert': '#b81237',
    'u-fillColorConfirm': '#53930f',
    'u-fillColorLime': '#bdd753',
    'u-fillColorDarkMint': '#007886',
    'u-fillColorData1': '#8ea71e',
    'u-fillColorData2': '#5d378c',
    'u-fillColorData3': '#7fcbc4',
    'u-fillColorData4': '#fdd835',
    'u-fillColorData5': '#f99d19',
    'u-fillColorData6': '#d17b00',
    'u-fillColorData7': '#8148fe',
    'u-fillColorData8': '#8e9496',
    'u-fillColorData9': '#c02c83',
    'u-fillColorData10': '#2aa7e1',
    'u-fillColorData11': '#a5cee0',
    'u-fillColorData12': '#d5e26b',
    'u-fillColorData13': '#1f7107',
    'u-fillColorData14': '#00acc1',
    'u-fillColorData15': '#40474a',
    'u-fillColorData16': '#fb4c54',
    'u-fillColorData17': '#f06292',
    'u-fillColorData18': '#ffafaf',
  }
  if (glyphs[color as keyof typeof glyphs]) {
    return glyphs[color as keyof typeof glyphs]
  }
  return 'u-fillColorBrand'
}

export const setBrandIconClass = (
  stylesDropdown: string | undefined,
  enableBorder: boolean | undefined | string,
  iconsColorsDropdown: string | undefined
) => {
  let iconClass = ''
  if (stylesDropdown?.endsWith('brand-icons-fill-colors')) {
    if (enableBorder) {
      iconClass = 'BrandIcon--withFillColorBorder'
    } else {
      iconClass = 'BrandIcon--default'
    }
  } else if (stylesDropdown?.endsWith('brand-icons-background-colors')) {
    iconClass =
      iconsColorsDropdown && iconsColorsDropdown === 'u-bgColorWhite'
        ? 'BrandIcon--withBgColor u-fillAmpfBlue'
        : 'BrandIcon--withBgColor u-fillColorWhite'
  } else {
    iconClass = 'BrandIcon--default'
  }
  return iconClass
}

export const brandIconSize = (size: string) => {
  let iconSize = ''
  switch (size) {
    case 'large':
      iconSize = 'u-sizeLarge'
      break
    case 'small':
      iconSize = 'u-sizeSmall'
      break
    default:
      iconSize = 'u-sizeDefault'
      break
  }
  return iconSize
}
